// values are query string params names
module.exports = {
    referralLinkCode: 'code',
    btag: 'btag',
    affId: 'affId',
    stag: 'stag',
};